import { FC, Fragment } from "react";
import UserListWebLayout from "pages/User/WebLayout";

const UserList: FC = () => {
  return (
    <Fragment>
      <UserListWebLayout />
      {/* <RolePermissionEditor
        allPermissions={permisisons.data}
        currentRolePermissions={adminRoles.data}
        role="admin"
      /> */}
    </Fragment>
  );
};

export default UserList;
